import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PluginComponent } from '../plugin.component';
import { Inspection } from '../../shared/models/index';
import { BasePlugin } from '../base-plugin.component';
import { AssistancePluginService } from './assistance-plugin.service';

@Component({
  templateUrl: './assistance.component.html',
  standalone: false
})
export class AssistancePluginComponent extends BasePlugin implements OnInit {
  public plugin: any = {};
  inspectionId: string;
  public inspection: Inspection;
  public assistances: any[];

  constructor(
    public assistanceService: AssistancePluginService,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {}

  config(
    plugin: any,
    inspection: Inspection,
    messages: Array<string>,
    showBreadcrumbs: boolean,
    showValidations: boolean,
    showContent: boolean
  ): void {
    super.config(plugin, inspection, messages, showBreadcrumbs, showValidations, showContent);
    this.assistances = this.plugin.config.Assistances;
    this.cdRef.detectChanges();
  }

  getEditRoute() {
    return [
      this.inspectionsRoute,
      this.inspection.id,
      'points',
      this.plugin.pointId ? this.plugin.pointId : -1,
      'plugins',
      this.plugin.id,
      'assistance',
      'edit'
    ];
  }
}

PluginComponent.plugins['assistance'] = AssistancePluginComponent;
